<template>
    <section class="section">
        <div class="container">
            <article class="panel is-info">
                <div class="panel-heading">
                    Амбалажи
                    <router-link :to="{name:'createSize'}" class="button is-success is-light pull-right is-small">
                        Креирај амбалажа
                    </router-link>
                </div>
                <div class="panel-block is-block" v-for="size in sizes" v-bind:key="size.id">
                    <div class="columns is-mobile is-paddingless">
                        <div class="column is-1">{{size.id}}</div>
                        <div class="column">{{size.name}}</div>
                        <div class="column">{{size.size}}</div>
                        <div class="column">
                            <div class="buttons is-right">
                                <router-link :to="{name:'editSize', params:{sizeId: size.id}}" class="is-small button is-link">
                                <span class="icon is-small">
                                    <i class="fa fa-pencil"></i>
                                </span>
                                </router-link>
                                <router-link :to="{name:'deleteSize', params:{sizeId: size.id}}"
                                             class="is-small button is-danger">
                                <span class="icon is-small">
                                    <i class="fa fa-remove"></i>
                                </span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-block" v-if="sizes.length === 0">
                    <Loading variant="is-white"/>
                </div>
            </article>
        </div>
        <router-view></router-view>
    </section>
</template>
<script>
    import Loading from "../../components/Loading";
    export default {
        name: "Sizes",
        components: {Loading},
        computed: {
            sizes: function () {
                return this.$store.getters.getSizes
            }
        }
    }
</script>
